/**
 * @generated SignedSource<<501459412e3b96f5a75d1be2b9b59f33>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type checkoutAuthActions_buyer$data = {
  readonly authMetadata: {
    readonly emailOnly: boolean | null;
  } | null;
  readonly profile: {
    readonly email: string | null;
  } | null;
  readonly socialNetworks: ReadonlyArray<{
    readonly socialId?: string | null;
    readonly socialNetwork?: {
      readonly name: string | null;
    } | null;
    readonly status?: string | null;
  } | null> | null;
  readonly " $fragmentType": "checkoutAuthActions_buyer";
};
export type checkoutAuthActions_buyer$key = {
  readonly " $data"?: checkoutAuthActions_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"checkoutAuthActions_buyer">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "checkoutAuthActions_buyer"
};

(node as any).hash = "3217325b8e931bdabf87477926797ce2";

export default node;
